export default __webpack_public_path__ + "static/media/planet4.31736126.png";